import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import { Base_url } from '../../utils/Base_url';
import axios from 'axios';
import Button from '../../components/Button';
import AddTeachers from './AddTeachers';
import { toast } from 'react-toastify';
import UpdateTeachers from './UpdateTeachers';
import { Link } from 'react-router-dom';
import Input from '../../components/Input';

const Teachers = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [addTeacherModal, setAddTeacherModal] = useState(false);
  const [cnicModal, setCnicModal] = useState(false);
  const [selectedCnicImage, setSelectedCnicImage] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    setLoading(true);
    fetch('https://quran-backend-theta.vercel.app/v1/user/all-teachers-details', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        console.log(data);

        setTeachers(data?.data);
        setLoading(false); // Set loading to false once data is received
      })
      .catch((error) => {
        console.error(error);
        setLoading(false); // In case of an error, stop loading
      });
  }, []);

  // Function to handle CNIC click and open modal
  const handleCnicClick = (cnicImage) => {
    setSelectedCnicImage(cnicImage); // Store CNIC image URL
    setCnicModal(true); // Open CNIC image modal
  };

  const filteredCourses = teachers?.filter((course) => {
    const matchesSearchQuery = course?.name?.toLowerCase()?.includes(searchQuery.toLowerCase());
    return matchesSearchQuery;
  });

  const handleChangeStatus = (newStatus, teacherId) => {
    const booleanStatus = JSON.parse(newStatus);

    // Update the specific teacher's loading state to true
    setTeachers((prevTeachers) =>
      prevTeachers.map((teacher) =>
        teacher._id === teacherId ? { ...teacher, isLoading: true } : teacher
      )
    );

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      userId: teacherId,
      status: booleanStatus
    });

    const requestOptions = {
      method: 'PATCH',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/profile-status', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === true) {
          // Update the status of the specific teacher and set loading to false
          setTeachers((prevTeachers) =>
            prevTeachers.map((teacher) =>
              teacher._id === teacherId
                ? { ...teacher, isActive: booleanStatus, isLoading: false }
                : teacher
            )
          );
        } else {
          // If the request fails, stop loading and show an error
          setTeachers((prevTeachers) =>
            prevTeachers.map((teacher) =>
              teacher._id === teacherId ? { ...teacher, isLoading: false } : teacher
            )
          );
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        console.error(error);
        // If an error occurs, stop loading
        setTeachers((prevTeachers) =>
          prevTeachers.map((teacher) =>
            teacher._id === teacherId ? { ...teacher, isLoading: false } : teacher
          )
        );
      });
  };

  const [updateTeachers, setUpdateTeachers] = useState(false);
  const [singleData, setSingleData] = useState({});
  return (
    <Wrapper
      searchBar={
        <Input
          placeholder={`Search by teacher name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      {/* Modal for adding teacher */}
      <AddTeachers setIsModalOpen={setAddTeacherModal} isModalOpen={addTeacherModal} />
      <UpdateTeachers
        setUsers={setTeachers}
        getData={singleData}
        setIsModalOpen={setUpdateTeachers}
        isModalOpen={updateTeachers}
      />

      <div className="flex justify-between items-center ">
        <div>
          <h2 className="main_title ">Teachers</h2>
          <p className="text-[#1C1D1D]">Here overview of the teachers</p>
        </div>
        <div className="cursor-pointer">
          <img
            onClick={() => setAddTeacherModal(true)} // Open the Add Teacher modal
            src={require('../../assets/image/add.png')}
            alt=""
          />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center">
          <p>Loading...</p>
        </div>
      ) : (
        <section className="mb-20 mt-7">
          <div className="rounded-lg overflow-x-auto">
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead className="">
                        <tr className="rounded-lg whitespace-nowrap">
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            ID
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Name
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Timing
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Email Address
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Password
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Phone no
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Address
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Qualification
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            CNIC Copy
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Status
                          </th>
                          <th scope="col" className="text-sm text-primary font-bold px-6 py-4">
                            Active
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredCourses?.map((teacher, index) => (
                          <tr key={teacher?._id} className="bg-white shadow-lg mt-6 rounded-lg">
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full">
                                {`000${index + 1}`}
                              </span>
                            </td>
                            <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                              <Link
                                to={`/teacher-student/${teacher?._id}?name=${encodeURIComponent(teacher?.name)}`}
                                className="bg-green-200 text-base text-secondary py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline rounded-full"
                              >
                                {teacher?.name}
                              </Link>
                            </td>
                            <td className="text-sm bg-white font-normal flex flex-col text-center px-6 py-4 whitespace-nowrap">
                              {teacher?.timeSlots?.map((item, index) => {
                                return (
                                  <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                    {`${item?.startTime}-${item?.endTime}`}
                                  </span>
                                );
                              })}
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.email}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className="bg-green-200 text-base text-black py-1 px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.password}
                              </span>
                            </td>
                            <td className="align-middle bg-white font-normal px-6 py-3 whitespace-nowrap text-left">
                              <div className="flex flex-col">
                                <span className="bg-green-200 text-xs text-[#858585] px-2.5 leading-none whitespace-nowrap rounded-full">
                                  Whatsapp no
                                </span>
                                <span className="bg-green-200 text-[#1C8E00] px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.phoneNumber}
                                </span>
                                <span className="bg-green-200 text-xs text-[#858585] px-2.5 leading-none whitespace-nowrap rounded-full">
                                  Other
                                </span>
                                <span className="bg-green-200 text-black px-2.5 leading-none whitespace-nowrap rounded-full">
                                  {teacher?.whatsappNumber}
                                </span>
                              </div>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className="bg-green-200 text-base text-black px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.address}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span className="bg-green-200 text-base text-black px-2.5 leading-none whitespace-nowrap rounded-full">
                                {teacher?.qualification}
                              </span>
                            </td>

                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              <span
                                className="bg-green-200 text-base text-secondary py-1 px-2.5 leading-none whitespace-nowrap rounded-full cursor-pointer"
                                onClick={() => handleCnicClick(teacher?.cnic)} // Handle CNIC click with URL
                              >
                                View CNIC
                              </span>
                            </td>

                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap text-left">
                              {!teacher?.isLoading ? (
                                <select
                                  className={`px-3 py-2 rounded-md ${
                                    teacher?.isActive
                                      ? 'bg-[#DFF7E3] text-[#23A118]' // Green background and text for active
                                      : 'bg-[#FCE8E6] text-[red]' // Red background and text for pending
                                  }`}
                                  value={teacher?.isActive}
                                  onChange={(e) => handleChangeStatus(e.target.value, teacher?._id)}
                                >
                                  <option
                                    value={true}
                                    className={teacher?.isActive ? 'text-[#23A118]' : ''}
                                  >
                                    Active
                                  </option>
                                  <option
                                    value={false}
                                    className={teacher?.isActive ? '' : 'text-red-500'}
                                  >
                                    Pending
                                  </option>
                                </select>
                              ) : (
                                <span className="ml-2 text-gray-500">Loading...</span>
                              )}
                            </td>

                            <td className="align-middle bg-white text-center text-sm font-normal px-6 whitespace-nowrap text-left">
                              <img
                                onClick={() => {
                                  setUpdateTeachers(true);
                                  setSingleData(teacher);
                                }}
                                className="w-6 h-6 cursor-pointer"
                                src={require('../../assets/image/edit.png')}
                                alt=""
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Modal to show CNIC image */}
      {cnicModal && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-4 rounded-lg shadow-xl relative max-w-sm w-full">
              {selectedCnicImage && (
                <img src={selectedCnicImage} alt="CNIC" className="w-full h-auto mb-4" />
              )}
              <div className="flex justify-end ">
                <button
                  onClick={() => setCnicModal(false)} // Replace with your state management to close the modal
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default Teachers;
